var _path, _path2;
import * as React from "react";
var SvgOwnedNfTs = function SvgOwnedNfTs(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.474.135c.326-.18.726-.18 1.052 0l9.939 5.492c.33.182.535.523.535.892v10.962c0 .369-.204.71-.535.892l-9.94 5.492c-.325.18-.725.18-1.05 0l-9.94-5.491A1.023 1.023 0 0 1 0 17.48V6.519c0-.369.204-.71.535-.892l9.94-5.492ZM11 1.977 1.912 6.998v10.004L11 22.023l9.088-5.021V6.998L11 1.977Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11 4.843 5.996 3.307-.947 1.61L11 6.974 5.961 9.759 5.014 8.15l5.985-3.307ZM16.996 15.85 11 19.157 5.013 15.85l.947-1.609 5.04 2.784 5.048-2.784.947 1.61Z"
  })));
};
export default SvgOwnedNfTs;